export const PI = 3.141592653589793 
export const HALF_PI = 1.5707963267948966;
export const QUARTER_PI = 0.7853981633974483;

export const TWO_PI = 6.283185307179586;

/** One degree in radians **/
export const ONE_DEGREE_IN_RADIANS = 0.017453292519943295; // i.e. PI / 180

/** One radian in degrees **/
export const ONE_RADIAN_IN_DEGREES = 57.29577951308232; // i.e. 180 / PI

/** The angle measure of a half turn in radians */
export const HALF_TURN = PI;

/** The angle measure of a quarter turn in radians */
export const QUARTER_TURN = HALF_PI;

/** The angle measure of an eighth turn in radians */
export const EIGHTH_TURN = QUARTER_PI;

/** The angle measure (in radians) of East, right, or +X */
export const DIRECTION_EAST = 0;

/** The angle measure (in radians) of North, up, or +Y (in three.js) */
export const DIRECTION_NORTH = HALF_PI;

/** The angle measure (in radians) of West, left, or -X */
export const DIRECTION_WEST = PI;

/**
 * The angle measure (in radians) of South, down, or -Y (in three.js), i.e.
 * 3pi/2
 */
export const DIRECTION_SOUTH = 4.71238898038469;
